// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelfChatPlaceholder_root__XGm6O {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
}

.SelfChatPlaceholder_content__c0NoR {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 300px;
  max-width: 100%;
}

.SelfChatPlaceholder_title__hcgaE {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #272A36;
  margin-top: 16px;
  margin-bottom: 24px;
}

.SelfChatPlaceholder_list__item__u6\\+Xa {
  text-align: left;
  display: flex;
  align-items: flex-start;
}
.SelfChatPlaceholder_list__item__u6\\+Xa:not(:last-child) {
  margin-bottom: 18px;
}
.SelfChatPlaceholder_list__item__icon__FWXLG {
  margin-right: 10px;
}
.SelfChatPlaceholder_list__item__text__hwbOH {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #272A36;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/SelfChatPlaceholder/SelfChatPlaceholder.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAAF;;AAIE;EAKE,gBAAA;EACA,aAAA;EACA,uBAAA;AALJ;AADI;EACE,mBAAA;AAGN;AAII;EACE,kBAAA;AAFN;AAKI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHN","sourcesContent":[".root {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 0;\n}\n\n.content {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  text-align: center;\n  width: 300px;\n  max-width: 100%;\n}\n\n.title {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #272A36;\n  margin-top: 16px;\n  margin-bottom: 24px;\n}\n\n.list {\n  &__item {\n    &:not(:last-child) {\n      margin-bottom: 18px;\n    }\n\n    text-align: left;\n    display: flex;\n    align-items: flex-start;\n\n    &__icon {\n      margin-right: 10px;\n    }\n\n    &__text {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 16px;\n      color: #272A36;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SelfChatPlaceholder_root__XGm6O`,
	"content": `SelfChatPlaceholder_content__c0NoR`,
	"title": `SelfChatPlaceholder_title__hcgaE`,
	"list__item": `SelfChatPlaceholder_list__item__u6+Xa`,
	"list__item__icon": `SelfChatPlaceholder_list__item__icon__FWXLG`,
	"list__item__text": `SelfChatPlaceholder_list__item__text__hwbOH`
};
export default ___CSS_LOADER_EXPORT___;
